import { dixaMessengerApi } from 'assets/components/settings/components/sections/dixaMessenger/api/apiProvider';
import { usePaginatedEndpoint } from 'hooks/usePaginatedEndpoint';
export const useMessengers = (initialParams) => usePaginatedEndpoint({
    endpoint: dixaMessengerApi.fetchAll,
    itemsSelector: (response) => response.messengers,
    initialParams: Object.assign({ sortKey: null }, initialParams),
});
